import {FAILURE, PENDING, SUCCESS} from '../../constants'

export const GU_FAILURE = `GET_USERS_${FAILURE}`
export const GU_PENDING = `GET_USERS_${PENDING}`
export const GU_SUCCESS = `GET_USERS_${SUCCESS}`

export const GSU_FAILURE = `GET_SEARCH_USERS_${FAILURE}`
export const GSU_PENDING = `GET_SEARCH_USERS_${PENDING}`
export const GSU_SUCCESS = `GET_SEARCH_USERS_${SUCCESS}`

export const GSUE_FAILURE = `GET_SEARCH_USERS_EMAIL_${FAILURE}`
export const GSUE_PENDING = `GET_SEARCH_USERS_EMAIL_${PENDING}`
export const GSUE_SUCCESS = `GET_SEARCH_USERS_EMAIL_${SUCCESS}`
